<template>
    <div class="gamesTables">
        <div class="games-entries">
            <div class="game-entry entry-header">
                <div class="date">{{__("gamestable.date")}}</div>
                <div class="matchtype">{{__("gamestable.match_type")}}</div>
                <div class="setslegs">{{__("gamestable.sets")}} & {{__("gamestable.legs")}}</div>
                <div class="options">{{__("gamestable.gameoptions")}}</div>
                <div class="lobby"></div>
                <div class="players">{{__("gamestable.players")}}</div>
                <div class="actions"></div>
            </div>
            <div class="game-entry" v-for="game in games" v-bind:key="game.id">
                <div class="date">
                   {{moment(game.created_at).fromNow()}}
                </div>
                <div class="matchtype">
                    <div class="badge-half steel-edart" v-if="game.boardtype == 0">
                            <i class="icn-kombiboard" title="Alle Boards"></i>
                            <span>{{game.matchtype.name}}</span>
                        </div>
                        <div class="badge-half steel" v-if="game.boardtype == 1">
                            <i class="icn-steelboard" title="Steel-Dart"></i>
                            <span>{{game.matchtype.name}}</span>
                        </div>
                        <div class="badge-half edart" v-if="game.boardtype == 2">
                            <i class="icn-eboard" title="E-Dart"></i>
                            <span>{{game.matchtype.name}}</span>
                        </div>
                    <span class="badge rounded-pill bg-danger text-light p-2 m-1" v-if="game.ranked"><i class="fas fa-medal" title="Ranglistenspiel"></i></span>
                </div>
                <div class="setslegs">
                    <span class="">{{__("gamestable.sets")}}: {{game.sets}}</span><span>{{__("gamestable.legs")}}: {{game.legs}}</span>
                </div>
                <div class="options">
                    <span class="badge rounded-pill bg-secondary text-light p-2 mr-1" v-for="item in game.options" v-bind:key="item.name">{{__(item.name)}}: {{__(item.value)}}</span>
                </div>
                <div class="players">
                    <div :class="[winnerCheck(slot, game) ? 'winnerbadge text-white' : '', 'text-truncate', 'game-player']" v-for="slot, idx in game.playerslots" :key="slot.id">
                        <div v-if="game.state['sets_player'+(idx+1)] != null" class="sets-legs-results">{{game.state['sets_player'+(idx+1)]}} | {{game.state['legs_player'+(idx+1)]}}</div>
                        <div v-if="slot.user && slot.user.player"><player-card :player="slot.user.player" :user="slot.user" class="game-player-name"/></div>
                        <div v-if="slot && slot.computer" class="game-player-name">{{__("gamestable.computer_lvl")}} {{slot.computer_level}}</div>
                        <div v-if="slot && slot.guest" class="game-player-name">{{__("gamestable.guest")}} {{slot.guestname}}</div>
                    </div>
                </div>
                <div class="actions">
                    <a href="#" @click="watch(game.id)" v-if="game.status == 'completed'" class="btn btn-secondary btn-block">
                        {{__("gamestable.result")}}
                    </a>
                    <a href="#" v-if="game.status == 'aborted'" class="btn btn-secondary btn-block disabled">{{__("gamestable.aborted")}}</a>
                    <a href="#" @click="watch(game.id)" v-if="game.status != 'aborted' && game.status != 'completed' && !inGamePlayerCheck(game)" class="btn btn-success btn-block">{{__("gamestable.watch")}}</a>
                    <a href="#" @click="join(game.id)" v-if="game.status != 'aborted' && game.status != 'completed' && inGamePlayerCheck(game)" class="btn btn-primary btn-block">{{__("gamestable.join")}}</a>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            user_id: {
                type: Number,
            },
            filter: {
                type: String
            }
        },
        data() {
            return {
                games: []
            }
        },
        mounted() {
            if (this.filter) {
                axios.get('/games?filter='+this.filter).then(response => {
                    this.games = response.data;
                });
            } else {
                axios.get('/games').then(response => {
                    this.games = response.data;
                });

                Echo.channel('games')
                    .listen('.game.created', (e) => {
                        console.log("UPDATE")
                        this.games = e.games;
                })
            }
        },
        methods: {
            watch(game_id) {
                toastSuccess('Starte Zuschauermodus');
                axios.post("/games/join", {game: game_id});
                // window.location.href = "/games/" + game_id;
            },
            join(game_id) {
                toastSuccess('Versuche beizutreten');
                axios.post("/games/join", {game: game_id});
                // window.location.href = "/games/" + game_id;
            },
            inGamePlayerCheck(game) {
                if (!game.playerslots) return false;
                let returnValue = false;
                game.playerslots.forEach(player => {
                    if (player.user_id == this.user_id) returnValue = true;
                });
                return returnValue;
            },
            winnerCheck(slot, game) {
                return game.winner_id && slot && slot.user && slot.user.player && game.winner_id == slot.user.player.id;
            }
        }
    }
</script>
